function initializeMap(lat, lng, pin_image_url, since_now_descriotion) {
  const DEFAULT_LATLNG = {lat: 35, lng: 135}
  var zoom = 15
  var mapDiv = document.getElementsByClassName("status-map")[0]

  // 一度も検知されていない場合はデフォルトの位置を表示する
  if(lat == "" && lng == ""){
    lat = DEFAULT_LATLNG.lat
    lng = DEFAULT_LATLNG.lng
    zoom = 1
  }

  var latlng = new google.maps.LatLng(lat, lng);

  mapDiv.style.width = '100%';

  map = new google.maps.Map(mapDiv, {
    center: latlng,
    zoom: zoom,
    mapTypeId: google.maps.MapTypeId.ROADMAP
  });
  marker = new google.maps.Marker({
    position: latlng,
    map: map,
    icon: {
      url: pin_image_url,
      scaledSize: new google.maps.Size(48, 48)
    }
  });
  var sinceNowWindow = new google.maps.InfoWindow({
     // 吹き出しに出す文
     content: since_now_descriotion,
     disableAutoPan: true
   });
   // 吹き出しを開く
   sinceNowWindow.open(map, marker);

   marker.addListener("click", () => {
     sinceNowWindow.open(map, marker);
   });
}

window.initializeMap = initializeMap;
